// extracted by mini-css-extract-plugin
export default {"container":"hN8eRoZ_Tw","name":"_3CTZB4-gFT","image":"_3dkWGmlvGR","info":"laf5xWdrse","info-item":"_1kQ3SD4Fdq","infoItem":"_1kQ3SD4Fdq","description":"_1tEzuf1uqE","links":"_2-YhIEvBIf"};
    if(module.hot) {
      // 1627035646226
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  